export default __webpack_public_path__ + "static/media/linkedin.97c14e72.svg";